/*
 * @Author: chenting chenting@cqliving.com
 * @Date: 2022-12-27 15:38:51
 * @LastEditors: chenting chenting@cqliving.com
 * @LastEditTime: 2022-12-27 16:25:49
 * @FilePath: \share-news-detail-pages\src\common\wechatapp.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: chenting chenting@cqliving.com
 * @Date: 2022-09-16 14:16:27
 * @LastEditors: chenting chenting@cqliving.com
 * @LastEditTime: 2022-12-27 16:04:17
 * @FilePath: \share-news-detail-pages\src\common\wechat.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import wxapp from "weixin-js-sdk"; // 引入wx
import request from "./request";
import { IWXResponse, IWXConfig } from "@/api/types";
import { hlxShareData } from "@/api/dataCollect/index";
/** *
 * 微信内h5 跳转到app
 */
export function wxChatJumpApp(
  configId: string,
  shareTitle: string,
  shareDesc: string,
  shareLink: string,
  shareImgUrl: string
) {
  // const url = `/getsc.html?a=${configId}&url=${encodeURIComponent(
  //   window.location.href.split("#")[0]
  // )}`;
  //
  // 新闻详情接口优化，接口更换
  const url = `https://gatewayapi.cqliving.com/cqliving-boot-sso/weChat/jsapiSignature?weChatId=${configId}&url=${encodeURIComponent(
    window.location.href.split("#")[0]
  )}`;
  // { baseURL: "//actweb.cqliving.com/weixin" }
  request.get<any, any>(url).then(res => {
    const { code, data: result } = res;
    if (code >= 0) {
      // const result = JSON.parse(data);
      // const result: IWXConfig = JSON.parse(data);
      // console.log(result);
      // 若要打印提示，则设置为true
      result.debug = true;
      wxapp.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: result.wxAppId, // 必填，公众号的唯一标识
        timestamp: result.timestamp, // 必填，生成签名的时间戳
        nonceStr: result.nonceStr, // 必填，生成签名的随机串
        signature: result.signature, // 必填，签名
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "wx-open-launch-app"
        ],
        openTagList: ["wx-open-launch-app"] // 跳转app
      });
      wxapp.ready(() => {
        console.log("注入成功app");
        // 分享到朋友圈
        wxapp.onMenuShareTimeline({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function () {
            // 分享埋点
            hlxShareData("分享给好友", "1", "");
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            hlxShareData("分享给好友", "0", "用户取消分享");
          },
        });

        // 分享给朋友
        wxapp.onMenuShareAppMessage({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function () {
            // 分享埋点
            hlxShareData("分享给好友", "1", "");
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            hlxShareData("分享给好友", "0", "用户取消分享");
          },
        });

        // 分享到QQ
        wxapp.onMenuShareQQ({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function () {
            // 分享埋点
            hlxShareData("分享给好友", "1", "");
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            hlxShareData("分享给好友", "0", "用户取消分享");
          },
        });

        // 分享到QQ
        wxapp.onMenuShareWeibo({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function () {
            // 分享埋点
            hlxShareData("分享给好友", "1", "");
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            hlxShareData("分享给好友", "0", "用户取消分享");
          },
        });
      });
      wxapp.error((e: any) => {
        console.log(e.detail);
      });
    }
  });
}
